import React from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as ChevronRight } from '../../assets/chevronRight.svg';
import styles from './TaskNavigationLink.module.css';

type Props = {
  count: number;
  dataId?: string;
  name: string;
  to: string;
};

export const TaskNavigationLink: React.FC<Props> = ({ dataId, to, name, count }) => (
  <NavLink data-id={dataId} className={styles.item} to={to}>
    <span className={styles.name}>{name}</span>
    <span className={styles.count}>
      {count} <ChevronRight className={styles.chevronRight} />
    </span>
  </NavLink>
);
